import classNames from 'classnames'
import React, { HTMLAttributes } from 'react'

interface FeildErrorProps extends HTMLAttributes<HTMLElement> {
  error?: string
  touched?: boolean
}

export const FieldError = ({
  className,
  error,
  touched,
  ...rest
}: FeildErrorProps) => {
  return (
    <small
      className={classNames(
        'block text-v3-red-400 font-workSans text-xs',
        className,
        {
          invisible: error === undefined || !touched
        }
      )}
      {...rest}
    >
      {touched && error ? error : 'error'}
    </small>
  )
}
